import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { FaQuestionCircle } from 'react-icons/fa';
import Text from 'v3/components/Text';
import Tooltip from 'v3/components/Tooltip';
import theme from 'v3/theme';
import { formatCurrency } from 'v3/utils/formatter';
import { AD_VALOREM_PERCENTAGE_PRECISION } from '../../context';

export default function ValueDetailsRow({
  label,
  percentageValue = null,
  value,
  dollarValue,
  obs = null,
  hasTooltip = false,
  tooltipContent = '',
  wasValueRemovedFromTotal = false,
  id,
  color = 'gray',
  labelColor = 'dark',
  weight = null,
  className = '',
}) {
  const hasPercentageValue =
    percentageValue !== null && percentageValue !== undefined;
  const percentageDecimals = hasPercentageValue
    ? String(percentageValue).split('.')[1]?.length ?? 0
    : 0;

  return (
    <Row className={className}>
      <Col xs={12} md={2}>
        <Text type="regular" color={labelColor} as="p" weight={weight || 500}>
          {label}
        </Text>
      </Col>
      {hasPercentageValue ? (
        <Col xs={12} md={1}>
          <Text
            type="regular"
            color="gray"
            style={{ wordBreak: 'break-word' }}
            as="p"
            weight={weight}
            title={percentageDecimals > AD_VALOREM_PERCENTAGE_PRECISION ? 'Valor aproximado' : ''}
            id={id && `label-${id}-porcentagem`}
          >
            {percentageDecimals > AD_VALOREM_PERCENTAGE_PRECISION ? (
              <span style={{ cursor: 'help' }} title="Valor aproximado">
                &#8776;
              </span>
            ) : null}
            {` ${percentageValue}%`}
          </Text>
        </Col>
      ) : (
        <Col md={1} />
      )}
      <Col className='d-flex' md={6} style={{
        paddingRight: '60px'
      }}>
        <Col xs={12} md={6}>  
          <Text
            weight={weight}
            type="regular"
            color={color}
            as="p"
            id={id && `label-${id}-real`}
          >
            {wasValueRemovedFromTotal && '-'}
            {formatCurrency(value, 'R$')}
          </Text>
        </Col>
        <Col xs={12} md={6}>
          <Text
            weight={weight}
            type="regular"
            color={color}
            as="p"
            id={id && `label-${id}-dolar`}
          >
            {wasValueRemovedFromTotal && '-'}
            {formatCurrency(dollarValue, 'USD', '$', 4)}
          </Text>
        </Col>
      </Col>
      <Col
        xs={12}
        md={3}
        style={{
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        {obs ? (
          <Text type="regular" color="gray" as="p">
            {obs}
          </Text>
        ) : null}
        {hasTooltip && (
          <Tooltip
            content={
              <Text type="label" color="white">
                {tooltipContent}
              </Text>
            }
          >
            <FaQuestionCircle style={{ color: theme.colors.light_blue }} />
          </Tooltip>
        )}
      </Col>
    </Row>
  );
}
